import {withNamespaces} from "react-i18next";
import React, {useEffect, useState} from "react";
import axios from "axios";
import SimpleBar from "simplebar-react";
import {AvField, AvForm} from "availity-reactstrap-validation";
import { DateTimePicker } from "react-widgets";
import {Alert} from "reactstrap";
import Select from "react-select";
import customStyles from "../../assets/select/customStyles";

const ReservierungEdit = (props) => {
    const [buchung, setBuchung] = useState({});
    const [departments, setDepartments] = useState([]);
    const [lotpreferences, setLotpreferences] = useState([]);
    const [allParkingscenarios, setAllParkingscenarios] = useState([]);
    const [currentParkingscenarios, setCurrentParkingscenarios] = useState([]);
    const [carParks, setCarParks] = useState([]);

    const [selectedLotPreference, setSelectedLotPreference] = useState();
    const [selectedDepartment, setSelectedDepartment] = useState();
    const [selectedScenario, setSelectedScenario] = useState();
    const [selectedCarPark, setSelectedCarPark] = useState();
    const [selectedTimeFrom, setSelectedTimeFrom] = useState();
    const [selectedTimeTill, setSelectedTimeTill] = useState();
   
    const [loaderShow, setLoaderShow] = useState(false);
    const [failShow, setFailShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const link = localStorage.getItem('link') + '/api/ReservationService';
    const newEntry = !(props.editId > 0);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
        loadData();
    }, []);

    const loadData = () => {
        setLoaderShow(true);

        axios.get(link + '/byid?id=' + (props.editId ?? ''), {}).then((response) => {
            console.debug(response.data);
            
            const carParks = response.data.carParks;
            
            setDepartments(response.data.departments);
            setLotpreferences(response.data.parkingLotPreferences);
            setCarParks(carParks);

            setBuchung(response.data.model);

            setSelectedLotPreference(response.data.model.parkingLotPreference);
            setSelectedDepartment(response.data.model.department);
            setSelectedScenario(response.data.model.scenario);

            const _selectedCarPark = carParks.find(cp => cp.value === response.data.model.areaIdCarpark);
            setSelectedCarPark(_selectedCarPark);

            if (props.editId > 0) {
                setSelectedTimeFrom(new Date(response.data.model.permissionFrom));
                setSelectedTimeTill(new Date(response.data.model.permissionTill));
            }

            setAllParkingscenarios(response.data.parkingScenariosByCarPark);
            changeCurrentParkingscenarios(response.data.parkingScenariosByCarPark, _selectedCarPark.value);

            setLoaderShow(false);
        })
            .catch((error) => {
                console.error("Error while loading Data", error);
                setLoaderShow(false);
            });
    }
    
    function changeCurrentParkingscenarios(allScenarios, selectedCarParkId) {
        const _currentScenarios = allScenarios[selectedCarParkId];
        setCurrentParkingscenarios(_currentScenarios);
    }

    function handleValidSubmit() {
        setFailShow(false);
        console.debug(buchung);
        axios
        ({
            method: newEntry ? 'post' : 'put',
            url: link,
            data: buchung,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                props.onChange();
            })
            .catch((error) => {
                const customError = getErrorMessage(error.response.status);
                if (customError) {
                    setErrorMessage(customError);
                } else {
                    console.error(error);
                    setErrorMessage(error.message);
                }
                setFailShow(true);
            });
        function getErrorMessage(statusCode) {
            switch (statusCode) {
                case 900:
                    return props.t("reservationService.quotaExceeded");
                case 901:
                    return props.t("reservationService.plateAllreadyReserved");
                case 902:
                    return props.t("reservationService.noCarParkGiven");
                case 903:
                    return props.t("reservationService.noTimeSpanGiven");
            }
            
            return null;
        }
    }

    return (
        <SimpleBar style={{width: "100%", height: "100%"}}>
            <div style={{width: "80%", margin: "auto"}}>
                <div style={{ marginTop: "20px" }}>
                    <h3>
                        {newEntry ? props.t("reservationService.reservationCreate") : props.t("reservationService.reservationEdit")}
                    </h3>
                    <AvForm
                        className="form-horizontal"
                        onValidSubmit={() => {
                            handleValidSubmit();
                        }}
                    >
                        {props.error && props.error ? (
                            <Alert color="danger">{props.error}</Alert>
                        ) : null}
                        <table border={0}>
                            <colgroup>
                                <col/>
                                <col/>
                            </colgroup>
                            <tbody>
                            <tr>
                                <td colSpan={2} style={{position: "relative", top: "-9px"}}>
                                    <div style={{marginBottom: "10px"}}>{props.t("reservationService.formHeader.carPark")}:</div>
                                    <Select
                                        styles={customStyles}
                                        name="areaIdCarpark"
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(carPark) => {
                                            buchung.areaIdCarpark = carPark.value;
                                            setBuchung(buchung);
                                            setSelectedCarPark(carPark);

                                            changeCurrentParkingscenarios(allParkingscenarios, carPark.value);
                                        }}
                                        options={carParks}
                                        value={selectedCarPark}
                                        required
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 3,
                                            colors: { ...theme.colors, primary: "#20a0ff" },
                                        })}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <AvField
                                        style={{ height: "25px" }} className="form-control"
                                        name="company"
                                        label={props.t("reservationService.formHeader.company") + ":"}
                                        value={buchung?.company ?? ''}
                                        onChange={(e) => {
                                            buchung.company = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.firstname ?? ''}
                                        name="firstname"
                                        label={props.t("reservationService.formHeader.firstname") + ":"}
                                        onChange={(e) => {
                                            buchung.firstname = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                                <td>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.lastname ?? ''}
                                        name="lastname"
                                        label={props.t("reservationService.formHeader.lastname") + ":"}
                                        onChange={(e) => {
                                            buchung.lastname = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.eMail ?? ''}
                                        name="eMail"
                                        label={props.t("reservationService.formHeader.email") + ":"}
                                        type="email"
                                        onChange={(e) => {
                                            buchung.eMail = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.numberPlate ?? ''}
                                        name="numberPlate"
                                        label={props.t("reservationService.formHeader.numberPlate") + ":"}
                                        required
                                        onChange={(e) => {
                                            buchung.numberPlate = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                                <td style={{position: "relative", top: "-9px"}}>
                                    <div style={{marginBottom: "10px"}}>{props.t("reservationService.formHeader.lotPreference")}:</div>
                                    <Select
                                        styles={customStyles}
                                        name="parkingLotPreference"
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(lotpreference) => {
                                            buchung.parkingLotPreference = lotpreference;
                                            buchung.parkingLotPreferenceValue = lotpreference.value;
                                            setBuchung(buchung);
                                            setSelectedLotPreference(lotpreference);
                                        }}
                                        options={lotpreferences}
                                        value={selectedLotPreference}
                                        required
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 3,
                                            colors: { ...theme.colors, primary: "#20a0ff" },
                                        })}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{marginBottom: "10px"}}>{props.t("reservationService.formHeader.from")}:</div>
                                    <DateTimePicker
                                        includeTime
                                        style={{ width: "100%" }}
                                        className="datetime-picker"
                                        value={selectedTimeFrom}
                                        required
                                        onChange={(value)=>{
                                            buchung.permissionFrom = value;
                                            setBuchung(buchung);
                                            setSelectedTimeFrom(value);
                                        }}
                                    />
                                </td>
                                <td>
                                    <div style={{marginBottom: "10px"}}>{props.t("reservationService.formHeader.till")}:</div>
                                    <DateTimePicker
                                        includeTime
                                        style={{ width: "100%" }}
                                        className="datetime-picker"
                                        value={selectedTimeTill}
                                        required
                                        onChange={(value)=>{
                                            buchung.permissionTill = value;
                                            setBuchung(buchung);
                                            setSelectedTimeTill(value);
                                        }}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td style={{paddingTop: "20px"}}>
                                    <div style={{marginBottom: "10px"}}>{props.t("reservationService.formHeader.department")}:</div>
                                    <Select
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(department) => {
                                            buchung.departmentId = department.value;
                                            buchung.department = department;
                                            setBuchung(buchung);
                                            setSelectedDepartment(department);
                                        }}
                                        options={departments}
                                        value={selectedDepartment}
                                    />
                                </td>
                                <td style={{paddingTop: "20px"}}>
                                    <div style={{marginBottom: "10px"}}>{props.t("reservationService.formHeader.scenario")}:</div>
                                    <Select
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(scenario) => {
                                            buchung.scenarioId = scenario.value;
                                            buchung.scenario = scenario;
                                            setBuchung(buchung);
                                            setSelectedScenario(scenario);
                                        }}
                                        options={currentParkingscenarios}
                                        value={selectedScenario}
                                    />
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan={2} style={{textAlign: "right", paddingTop: "20px"}}>
                                    <button className="button" onClick={() => props.onChange()} style={{width: "100px"}}>
                                        {props.t("allgemein.abbruch")}
                                    </button>
                                    
                                    <button type="submit" className="button" style={{width: "100px", marginLeft: "10px"}}>
                                        {props.t("allgemein.speichern")}
                                    </button>
                                </td>
                            </tr>
                            {failShow === true && (
                                <tr><td colSpan={2} style={{textAlign: "right", color: "#f46a6a"}}>{errorMessage}</td></tr>
                            )}
                            </tfoot>
                        </table>
                    </AvForm>
                </div>
            </div>
        </SimpleBar>
    );
};

export default withNamespaces()(ReservierungEdit);
